// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* buyerRequireList.css */

.buyer-container {
  padding: 20px;
  background: #0a0f1a;
  min-height: 100vh;
}

.header-bar{
display:flex;
justify-content:space-between;
align-items:flex-start;
margin-bottom:20px;
}

.search-wrapper{
width:300px;
}

.right-actions{
display:flex;
flex-direction:column;
align-items:flex-end;
gap:6px;
}

.add-btn{
padding:10px 18px;
background:#FBBF24;
border:none;
border-radius:8px;
font-weight:600;
cursor:pointer;
}

.pagination-info{
font-size:13px;
color:#9ca3af;
}

.search-wrapper {
  max-width: 300px;
}

.search-bar {
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #2a3548;
  border-radius: 8px;
  font-size: 14px;
  background: #151e2c;
  color: #ffffff;
  transition: all 0.3s;
}

.search-bar::placeholder {
  color: #6b7a8f;
}

.search-bar:focus {
  outline: none;
  border-color: #b8860b;
  box-shadow: 0 0 0 3px rgba(184, 134, 11, 0.2);
  background: #1a2434;
}

/* Table Styles */
.buyer-table {
  width: 100%;
  border-collapse: collapse;
  background: #0f172a;
  border-radius: 12px;
  overflow: hidden;
}

.buyer-table th {
  padding: 15px;
  font-weight: 600;
  color: #b8860b;
  background: #1a2538;
  border-bottom: 2px solid #b8860b;
  text-align: left;
  font-size: 14px;
}

.buyer-table td {
  padding: 15px;
  border-bottom: 1px solid #253040;
  color: #e5e7eb;
}

.buyer-table tbody tr:hover {
  background: #1a2538;
}

.req-id {
  font-weight: 600;
  color: #b8860b;
}

.buyer-info {
  display: flex;
  flex-direction: column;
}

.buyer-name {
  font-weight: 500;
  color: #ffffff;
}

.buyer-phone {
  font-size: 12px;
  color: #9ca3af;
}

/* Status Badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
}

.status-inprocess {
  background: rgba(255, 193, 7, 0.15);
  color: #ffc107;
  border: 1px solid rgba(255, 193, 7, 0.3);
}

.status-matched {
  background: rgba(40, 167, 69, 0.15);
  color: #28a745;
  border: 1px solid rgba(40, 167, 69, 0.3);
}

.status-delivered {
  background: rgba(0, 123, 255, 0.15);
  color: #007bff;
  border: 1px solid rgba(0, 123, 255, 0.3);
}

.status-cancelled {
  background: rgba(220, 53, 69, 0.15);
  color: #dc3545;
  border: 1px solid rgba(220, 53, 69, 0.3);
}

/* Action Icons */
.action-icons {
  display: flex;
  gap: 12px;
  align-items: center;
}

.icon-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  border-radius: 6px;
}

.icon-btn.view {
  color: #3b82f6;
  background: rgba(59, 130, 246, 0.1);
}

.icon-btn.send {
  color: #b8860b;
  background: rgba(184, 134, 11, 0.1);
}

.icon-btn.invoice {
  color: #10b981;
  background: rgba(16, 185, 129, 0.1);
}

.icon-btn.response {
  color: #8b5cf6;
  background: rgba(139, 92, 246, 0.1);
}

.icon-btn:hover {
  transform: scale(1.1);
  opacity: 0.9;
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* Share Modal */
.share-modal {
  background: #0f172a;
  width: 550px;
  max-width: 90%;
  border-radius: 16px;
  border: 1px solid #b8860b;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.5), 0 10px 10px -5px rgba(0, 0, 0, 0.4);
  animation: modalFadeIn 0.3s ease;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.share-modal .modal-header {
  padding: 20px 24px;
  border-bottom: 2px solid #b8860b;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(to right, #0f172a, #1a2538);
  border-radius: 16px 16px 0 0;
}

.share-modal .modal-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #b8860b;
  letter-spacing: 0.5px;
}

.close-btn {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  cursor: pointer;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 8px;
  font-size: 20px;
  width: 36px;
  height: 36px;
  transition: all 0.2s;
}

.close-btn:hover {
  background: rgba(184, 134, 11, 0.2);
  color: #b8860b;
}

.share-modal .modal-body {
  padding: 24px;
}

/* Requirement Title */
.requirement-title {
  font-size: 14px;
  font-weight: 500;
  color: #b8860b;
  margin-bottom: 12px;
  letter-spacing: 0.5px;
}

/* Requirement Card */
.requirement-card {
  background: #1a2538;
  border: 1px solid #2a3548;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
}

.requirement-detail {
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 8px;
}

.requirement-description {
  font-size: 13px;
  color: #9ca3af;
  border-top: 1px dashed #2a3548;
  padding-top: 8px;
  line-height: 1.5;
}

/* Sellers Section */
.sellers-section {
  margin-bottom: 24px;
}

.sellers-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.sellers-header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
}

.select-all-btn {
  background: transparent;
  border: 1px solid #b8860b;
  color: #b8860b;
  font-size: 12px;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 20px;
  transition: all 0.2s;
}

.select-all-btn:hover {
  background: #b8860b;
  color: #000000;
}

.sellers-list {
  background: #0f172a;
  border: 1px solid #2a3548;
  border-radius: 12px;
  max-height: 250px;
  overflow-y: auto;
}

.sellers-list::-webkit-scrollbar {
  width: 6px;
}

.sellers-list::-webkit-scrollbar-track {
  background: #1a2538;
  border-radius: 10px;
}

.sellers-list::-webkit-scrollbar-thumb {
  background: #b8860b;
  border-radius: 10px;
}

.seller-item {
  padding: 12px 16px;
  border-bottom: 1px solid #2a3548;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.2s;
}

.seller-item:last-child {
  border-bottom: none;
}

.seller-item:hover {
  background: #1a2538;
}

.seller-label {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  flex: 1 1;
}

.seller-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #b8860b;
}

.seller-name {
  font-size: 14px;
  color: #ffffff;
  font-weight: 500;
}

.seller-categories {
  font-size: 12px;
  color: #b8860b;
  background: rgba(184, 134, 11, 0.1);
  padding: 4px 10px;
  border-radius: 20px;
}

/* Modal Footer */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #2a3548;
}

.cancel-btn {
  padding: 10px 20px;
  border: 1px solid #2a3548;
  background: transparent;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s;
}

.cancel-btn:hover {
  background: #2a3548;
}

.share-btn {
  padding: 10px 24px;
  border: none;
  background: #b8860b;
  color: #000000;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s;
}

.share-btn:hover:not(:disabled) {
  background: #daa520;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(184, 134, 11, 0.3);
}

.share-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Loading State */
.loading-sellers {
  text-align: center;
  padding: 30px;
  color: #9ca3af;
  font-size: 14px;
}

.no-sellers {
  text-align: center;
  padding: 30px;
  color: #6b7a8f;
  font-size: 14px;
  font-style: italic;
}

/* Invoice Modal */
.invoice-modal {
  width: 95%;
  max-width: 900px;
  max-height: 95vh;
  overflow-y: auto;
  background: #0f172a;
  border-radius: 16px;
  border: 1px solid #b8860b;
}

.invoice-card {
  background: #0f172a;
  padding: 24px;
  border-radius: 16px;
  color: #ffffff;
}

/* Response Modal */
.response-modal {
  width: 550px;
  background: #0f172a;
  border-radius: 16px;
  border: 1px solid #b8860b;
  animation: modalFadeIn 0.3s ease;
}

.response-modal .modal-header {
  padding: 20px 24px;
  border-bottom: 2px solid #b8860b;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(to right, #0f172a, #1a2538);
  border-radius: 16px 16px 0 0;
}

.response-modal .modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #b8860b;
}

.response-summary {
  display: flex;
  justify-content: space-between;
  background: #1a2538;
  padding: 16px 20px;
  border-radius: 12px;
  margin: 20px 24px;
  border: 1px solid #2a3548;
}

.response-summary > div {
  font-size: 14px;
  font-weight: 500;
}

.response-summary .accepted {
  color: #28a745;
}

.response-summary .rejected {
  color: #dc3545;
}

.response-summary .pending {
  color: #ffc107;
}

.response-list {
  padding: 0 24px 24px;
  max-height: 350px;
  overflow-y: auto;
}

.response-list::-webkit-scrollbar {
  width: 6px;
}

.response-list::-webkit-scrollbar-track {
  background: #1a2538;
  border-radius: 10px;
}

.response-list::-webkit-scrollbar-thumb {
  background: #b8860b;
  border-radius: 10px;
}

.response-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #1a2538;
  padding: 16px;
  border-radius: 12px;
  margin-bottom: 12px;
  border: 1px solid #2a3548;
  transition: all 0.2s;
}

.response-item:hover {
  border-color: #b8860b;
  transform: translateX(2px);
}

.response-item strong {
  color: #ffffff;
  font-size: 15px;
  display: block;
  margin-bottom: 4px;
}

.response-item div:first-child div {
  color: #9ca3af;
  font-size: 13px;
}

.status-pill {
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-pill.accepted {
  background: rgba(40, 167, 69, 0.15);
  color: #28a745;
  border: 1px solid rgba(40, 167, 69, 0.3);
}

.status-pill.rejected {
  background: rgba(220, 53, 69, 0.15);
  color: #dc3545;
  border: 1px solid rgba(220, 53, 69, 0.3);
}

.status-pill.pending {
  background: rgba(255, 193, 7, 0.15);
  color: #ffc107;
  border: 1px solid rgba(255, 193, 7, 0.3);
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 30px;
}

.pagination button {
  padding: 8px 20px;
  border: 1px solid #2a3548;
  background: #0f172a;
  color: #ffffff;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
}

.pagination button:hover:not(:disabled) {
  background: #b8860b;
  color: #000000;
  border-color: #b8860b;
}

.pagination button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.pagination span {
  color: #9ca3af;
  font-size: 14px;
}

/* Responsive */
@media (max-width: 768px) {
  .buyer-container {
    padding: 10px;
  }
  
  .share-modal,
  .response-modal {
    width: 95%;
  }
  
  .action-icons {
    gap: 6px;
  }
  
  .icon-btn {
    padding: 6px;
  }
  
  .response-summary {
    flex-wrap: wrap;
    gap: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/BuyerRequirement/BuyerRequirementList/buyerRequireList.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;AACA,YAAY;AACZ,6BAA6B;AAC7B,sBAAsB;AACtB,kBAAkB;AAClB;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,YAAY;AACZ,qBAAqB;AACrB,oBAAoB;AACpB,OAAO;AACP;;AAEA;AACA,iBAAiB;AACjB,kBAAkB;AAClB,WAAW;AACX,iBAAiB;AACjB,eAAe;AACf,cAAc;AACd;;AAEA;AACA,cAAc;AACd,aAAa;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oFAAoF;EACpF,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uDAAuD;EACvD,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uDAAuD;EACvD,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,SAAS;EACX;AACF","sourcesContent":["/* buyerRequireList.css */\n\n.buyer-container {\n  padding: 20px;\n  background: #0a0f1a;\n  min-height: 100vh;\n}\n\n.header-bar{\ndisplay:flex;\njustify-content:space-between;\nalign-items:flex-start;\nmargin-bottom:20px;\n}\n\n.search-wrapper{\nwidth:300px;\n}\n\n.right-actions{\ndisplay:flex;\nflex-direction:column;\nalign-items:flex-end;\ngap:6px;\n}\n\n.add-btn{\npadding:10px 18px;\nbackground:#FBBF24;\nborder:none;\nborder-radius:8px;\nfont-weight:600;\ncursor:pointer;\n}\n\n.pagination-info{\nfont-size:13px;\ncolor:#9ca3af;\n}\n\n.search-wrapper {\n  max-width: 300px;\n}\n\n.search-bar {\n  width: 100%;\n  padding: 10px 15px;\n  border: 1px solid #2a3548;\n  border-radius: 8px;\n  font-size: 14px;\n  background: #151e2c;\n  color: #ffffff;\n  transition: all 0.3s;\n}\n\n.search-bar::placeholder {\n  color: #6b7a8f;\n}\n\n.search-bar:focus {\n  outline: none;\n  border-color: #b8860b;\n  box-shadow: 0 0 0 3px rgba(184, 134, 11, 0.2);\n  background: #1a2434;\n}\n\n/* Table Styles */\n.buyer-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #0f172a;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.buyer-table th {\n  padding: 15px;\n  font-weight: 600;\n  color: #b8860b;\n  background: #1a2538;\n  border-bottom: 2px solid #b8860b;\n  text-align: left;\n  font-size: 14px;\n}\n\n.buyer-table td {\n  padding: 15px;\n  border-bottom: 1px solid #253040;\n  color: #e5e7eb;\n}\n\n.buyer-table tbody tr:hover {\n  background: #1a2538;\n}\n\n.req-id {\n  font-weight: 600;\n  color: #b8860b;\n}\n\n.buyer-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.buyer-name {\n  font-weight: 500;\n  color: #ffffff;\n}\n\n.buyer-phone {\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n/* Status Badges */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.status-inprocess {\n  background: rgba(255, 193, 7, 0.15);\n  color: #ffc107;\n  border: 1px solid rgba(255, 193, 7, 0.3);\n}\n\n.status-matched {\n  background: rgba(40, 167, 69, 0.15);\n  color: #28a745;\n  border: 1px solid rgba(40, 167, 69, 0.3);\n}\n\n.status-delivered {\n  background: rgba(0, 123, 255, 0.15);\n  color: #007bff;\n  border: 1px solid rgba(0, 123, 255, 0.3);\n}\n\n.status-cancelled {\n  background: rgba(220, 53, 69, 0.15);\n  color: #dc3545;\n  border: 1px solid rgba(220, 53, 69, 0.3);\n}\n\n/* Action Icons */\n.action-icons {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.icon-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  border-radius: 6px;\n}\n\n.icon-btn.view {\n  color: #3b82f6;\n  background: rgba(59, 130, 246, 0.1);\n}\n\n.icon-btn.send {\n  color: #b8860b;\n  background: rgba(184, 134, 11, 0.1);\n}\n\n.icon-btn.invoice {\n  color: #10b981;\n  background: rgba(16, 185, 129, 0.1);\n}\n\n.icon-btn.response {\n  color: #8b5cf6;\n  background: rgba(139, 92, 246, 0.1);\n}\n\n.icon-btn:hover {\n  transform: scale(1.1);\n  opacity: 0.9;\n}\n\n/* Modal Overlay */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n/* Share Modal */\n.share-modal {\n  background: #0f172a;\n  width: 550px;\n  max-width: 90%;\n  border-radius: 16px;\n  border: 1px solid #b8860b;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.5), 0 10px 10px -5px rgba(0, 0, 0, 0.4);\n  animation: modalFadeIn 0.3s ease;\n}\n\n@keyframes modalFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.share-modal .modal-header {\n  padding: 20px 24px;\n  border-bottom: 2px solid #b8860b;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: linear-gradient(to right, #0f172a, #1a2538);\n  border-radius: 16px 16px 0 0;\n}\n\n.share-modal .modal-header h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #b8860b;\n  letter-spacing: 0.5px;\n}\n\n.close-btn {\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  cursor: pointer;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  border-radius: 8px;\n  font-size: 20px;\n  width: 36px;\n  height: 36px;\n  transition: all 0.2s;\n}\n\n.close-btn:hover {\n  background: rgba(184, 134, 11, 0.2);\n  color: #b8860b;\n}\n\n.share-modal .modal-body {\n  padding: 24px;\n}\n\n/* Requirement Title */\n.requirement-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: #b8860b;\n  margin-bottom: 12px;\n  letter-spacing: 0.5px;\n}\n\n/* Requirement Card */\n.requirement-card {\n  background: #1a2538;\n  border: 1px solid #2a3548;\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 24px;\n}\n\n.requirement-detail {\n  font-size: 15px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 8px;\n}\n\n.requirement-description {\n  font-size: 13px;\n  color: #9ca3af;\n  border-top: 1px dashed #2a3548;\n  padding-top: 8px;\n  line-height: 1.5;\n}\n\n/* Sellers Section */\n.sellers-section {\n  margin-bottom: 24px;\n}\n\n.sellers-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.sellers-header h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.select-all-btn {\n  background: transparent;\n  border: 1px solid #b8860b;\n  color: #b8860b;\n  font-size: 12px;\n  cursor: pointer;\n  padding: 6px 12px;\n  border-radius: 20px;\n  transition: all 0.2s;\n}\n\n.select-all-btn:hover {\n  background: #b8860b;\n  color: #000000;\n}\n\n.sellers-list {\n  background: #0f172a;\n  border: 1px solid #2a3548;\n  border-radius: 12px;\n  max-height: 250px;\n  overflow-y: auto;\n}\n\n.sellers-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sellers-list::-webkit-scrollbar-track {\n  background: #1a2538;\n  border-radius: 10px;\n}\n\n.sellers-list::-webkit-scrollbar-thumb {\n  background: #b8860b;\n  border-radius: 10px;\n}\n\n.seller-item {\n  padding: 12px 16px;\n  border-bottom: 1px solid #2a3548;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: background 0.2s;\n}\n\n.seller-item:last-child {\n  border-bottom: none;\n}\n\n.seller-item:hover {\n  background: #1a2538;\n}\n\n.seller-label {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  flex: 1;\n}\n\n.seller-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: #b8860b;\n}\n\n.seller-name {\n  font-size: 14px;\n  color: #ffffff;\n  font-weight: 500;\n}\n\n.seller-categories {\n  font-size: 12px;\n  color: #b8860b;\n  background: rgba(184, 134, 11, 0.1);\n  padding: 4px 10px;\n  border-radius: 20px;\n}\n\n/* Modal Footer */\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 20px;\n  border-top: 1px solid #2a3548;\n}\n\n.cancel-btn {\n  padding: 10px 20px;\n  border: 1px solid #2a3548;\n  background: transparent;\n  color: #ffffff;\n  font-size: 14px;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: all 0.2s;\n}\n\n.cancel-btn:hover {\n  background: #2a3548;\n}\n\n.share-btn {\n  padding: 10px 24px;\n  border: none;\n  background: #b8860b;\n  color: #000000;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: all 0.2s;\n}\n\n.share-btn:hover:not(:disabled) {\n  background: #daa520;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(184, 134, 11, 0.3);\n}\n\n.share-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Loading State */\n.loading-sellers {\n  text-align: center;\n  padding: 30px;\n  color: #9ca3af;\n  font-size: 14px;\n}\n\n.no-sellers {\n  text-align: center;\n  padding: 30px;\n  color: #6b7a8f;\n  font-size: 14px;\n  font-style: italic;\n}\n\n/* Invoice Modal */\n.invoice-modal {\n  width: 95%;\n  max-width: 900px;\n  max-height: 95vh;\n  overflow-y: auto;\n  background: #0f172a;\n  border-radius: 16px;\n  border: 1px solid #b8860b;\n}\n\n.invoice-card {\n  background: #0f172a;\n  padding: 24px;\n  border-radius: 16px;\n  color: #ffffff;\n}\n\n/* Response Modal */\n.response-modal {\n  width: 550px;\n  background: #0f172a;\n  border-radius: 16px;\n  border: 1px solid #b8860b;\n  animation: modalFadeIn 0.3s ease;\n}\n\n.response-modal .modal-header {\n  padding: 20px 24px;\n  border-bottom: 2px solid #b8860b;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: linear-gradient(to right, #0f172a, #1a2538);\n  border-radius: 16px 16px 0 0;\n}\n\n.response-modal .modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #b8860b;\n}\n\n.response-summary {\n  display: flex;\n  justify-content: space-between;\n  background: #1a2538;\n  padding: 16px 20px;\n  border-radius: 12px;\n  margin: 20px 24px;\n  border: 1px solid #2a3548;\n}\n\n.response-summary > div {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.response-summary .accepted {\n  color: #28a745;\n}\n\n.response-summary .rejected {\n  color: #dc3545;\n}\n\n.response-summary .pending {\n  color: #ffc107;\n}\n\n.response-list {\n  padding: 0 24px 24px;\n  max-height: 350px;\n  overflow-y: auto;\n}\n\n.response-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.response-list::-webkit-scrollbar-track {\n  background: #1a2538;\n  border-radius: 10px;\n}\n\n.response-list::-webkit-scrollbar-thumb {\n  background: #b8860b;\n  border-radius: 10px;\n}\n\n.response-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #1a2538;\n  padding: 16px;\n  border-radius: 12px;\n  margin-bottom: 12px;\n  border: 1px solid #2a3548;\n  transition: all 0.2s;\n}\n\n.response-item:hover {\n  border-color: #b8860b;\n  transform: translateX(2px);\n}\n\n.response-item strong {\n  color: #ffffff;\n  font-size: 15px;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.response-item div:first-child div {\n  color: #9ca3af;\n  font-size: 13px;\n}\n\n.status-pill {\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-pill.accepted {\n  background: rgba(40, 167, 69, 0.15);\n  color: #28a745;\n  border: 1px solid rgba(40, 167, 69, 0.3);\n}\n\n.status-pill.rejected {\n  background: rgba(220, 53, 69, 0.15);\n  color: #dc3545;\n  border: 1px solid rgba(220, 53, 69, 0.3);\n}\n\n.status-pill.pending {\n  background: rgba(255, 193, 7, 0.15);\n  color: #ffc107;\n  border: 1px solid rgba(255, 193, 7, 0.3);\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  margin-top: 30px;\n}\n\n.pagination button {\n  padding: 8px 20px;\n  border: 1px solid #2a3548;\n  background: #0f172a;\n  color: #ffffff;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 14px;\n}\n\n.pagination button:hover:not(:disabled) {\n  background: #b8860b;\n  color: #000000;\n  border-color: #b8860b;\n}\n\n.pagination button:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.pagination span {\n  color: #9ca3af;\n  font-size: 14px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .buyer-container {\n    padding: 10px;\n  }\n  \n  .share-modal,\n  .response-modal {\n    width: 95%;\n  }\n  \n  .action-icons {\n    gap: 6px;\n  }\n  \n  .icon-btn {\n    padding: 6px;\n  }\n  \n  .response-summary {\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
